export const MAXWELL_IA_GENERAR_URL = "MAXWELL_IA_GENERAR_URL";
export const MAXWELL_IA_ERROR = "MAXWELL_IA_ERROR";

function base64UrlEncode(obj) {
    const json = JSON.stringify(obj);
    const bytes = new TextEncoder().encode(json);
    let binary = '';
    bytes.forEach(b => { binary += String.fromCharCode(b); });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

async function generarJWT(email, name, secret, expiresInSeconds) {
    const header = { alg: 'HS256', typ: 'JWT' };
    const now = Math.floor(Date.now() / 1000);
    const jti = crypto.randomUUID();
    const payload = { email, name, iat: now, exp: now + expiresInSeconds, jti };

    const headerEncoded  = base64UrlEncode(header);
    const payloadEncoded = base64UrlEncode(payload);
    const signingInput   = `${headerEncoded}.${payloadEncoded}`;

    const key = await crypto.subtle.importKey(
        'raw',
        new TextEncoder().encode(secret),
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign']
    );

    const signatureBuffer = await crypto.subtle.sign('HMAC', key, new TextEncoder().encode(signingInput));
    const signatureBytes  = new Uint8Array(signatureBuffer);
    let signatureBinary   = '';
    signatureBytes.forEach(b => { signatureBinary += String.fromCharCode(b); });
    const signatureEncoded = btoa(signatureBinary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');

    return `${signingInput}.${signatureEncoded}`;
}

export function cargarSSOUrl(email, nombre) {
    return async (dispatch) => {
        if (!maxwellSsoSecret) {
            dispatch({ type: MAXWELL_IA_ERROR, mensaje: 'MaxwellSsoSecret no está configurado en apis.json.' });
            return;
        }
        try {
            const token  = await generarJWT(email, nombre, maxwellSsoSecret, maxwellSsoTokenExpiresInSeconds);
            const ssoUrl = `${maxwellUrl}/auth?sso_token=${token}`;
            dispatch({ type: MAXWELL_IA_GENERAR_URL, ssoUrl });
        } catch (err) {
            console.error('[Maxwell IA] SSO error:', err);
            dispatch({ type: MAXWELL_IA_ERROR, mensaje: `Error al generar el token SSO: ${err.message}` });
        }
    };
}
